import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import globals from '@/plugins/globals'
const baseUrl = window.config ? `${window.config.apiUrl}/user` : null

const roleId = {
  shop: ['15', '16', '17'],
  center: [],
  partner: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14']
}

// this should be an api call but for now we just hard code
const PAGE_PERMISSIONS = {
  '/login': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
  '/locations': [1, 2, 3, 5, 7, 9, 12, 15],
  '/pricing-rules': [1],
  // Issue 622: uploading an estimate is open to all roles. BPCP has no review listing page.
  '/upload-estimate': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
}

export const authStore = defineStore('auth', {
  state: () => ({
    // initialize state from local storage to enable user to stay logged in
    token: JSON.parse(sessionStorage.getItem('token')),
    profile: sessionStorage.getItem('profile') ? JSON.parse(sessionStorage.getItem('profile')) : { username: null, password: null, roles: [] }
  }),
  actions: {
    async login(username, password) {
      const token = await api.post(`${baseUrl}/getToken`, { username, password, IsBlueprint: 1 })
      if (token) {
        await this.processToken(token)
        try {
          if (this.profile.isBlueprint) {
            let mcpToken = await api.post('blueprint/mcpToken?removeFile', { username, password })
            this.profile.mcpToken = mcpToken

            let eulas = await api.get(`user/userRequiredEULAs?username=${username}`)
            console.log('EULA Requirements:', eulas)
            this.profile.requiredEULAs = eulas
            sessionStorage.setItem('profile', JSON.stringify(this.profile))
          }
        } catch (error) {
          console.error('Error fetching MCP Token:', error)
        }
      }
    },
    setData(data) {
      switch (data.name) {
        case 'username':
          this.profile.username = data.value
          break
        case 'password':
          this.profile.password = data.value
          break
      }
    },
    clearToken() {
      this.token = null
      this.profile = null
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('profile')
    },
    logout() {
      this.token = null
      this.profile = null
      sessionStorage.clear()
      this.$router.push('/login')
    },
    // Takes the page path directly. This was previously a no-arg action that returned a closure,
    // while every caller (the router guard and NavLeft) passed the path straight in and got the
    // closure back. A function is truthy, so no entry in PAGE_PERMISSIONS was ever enforced.
    isAllowed(page = '') {
      if (!PAGE_PERMISSIONS[page]) {
        return true
      }
      if (this.profile && this.profile.roles && this.profile.roles.length) {
        return this.profile.roles.some((r) => PAGE_PERMISSIONS[page].includes(r))
      }
      return PAGE_PERMISSIONS[page].includes('Guest')
    },
    async resetPassword(data) {
      return await api.post('user/resetPassword', data)
    },
    async updateUserParams(data) {
      return await api.post('user/updateUserParams', data)
    },
    // for SSO login
    async redeemTempToken(tempToken) {
      let token = await api.post(`${baseUrl}/redeemTempToken`, tempToken)
      if (token) {
        await this.processToken(token)
      }
    },
    async processToken(token) {
      this.token = token.slice(1, -1)
      // store the token to a session variable
      sessionStorage.setItem('token', JSON.stringify(token.slice(1, -1)))
      // decode the token
      var base64Url = token.split('.')[1]
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          })
          .join('')
      )
      // parse the payload
      var tokenPayload = JSON.parse(jsonPayload)
      // establish a profile
      let profile = {
        user: parseInt(tokenPayload.uid),
        contact: parseInt(tokenPayload.cid),
        firm: parseInt(tokenPayload.fid),
        timezone: parseInt(tokenPayload.tz),
        firstName: tokenPayload.fname,
        lastName: tokenPayload.lname,
        username: tokenPayload.uname,
        email: tokenPayload.email,
        language: tokenPayload.cc,
        roles: [],
        isBlueprint: tokenPayload.isBlueprint || true,
        isBlueprintFirm: tokenPayload.isBlueprintFirm || false
      }
      profile.roles.push(parseInt(tokenPayload.rid))
      // save the profile to a session variable
      sessionStorage.setItem('profile', JSON.stringify(profile))
      this.profile = profile
      // let response = await api.get(`firm/preferences?firm=${profile.firm}&category=General`)
      // if (response) {
      //   if (response !== '') {
      //     console.log(response)
      //     response.map((item) => {
      //       if (item.name == 'Logo') {
      //         sessionStorage.setItem('Logo', item.value)
      //         return item.value
      //       }
      //     })
      //   }
      // }
    },
    async acceptEula(eula) {
      await api.post(`user/eulaUserAccepted?eula=${eula.EULA}&user=${this.profile.user}`)
      let eulas = await api.get(`user/userRequiredEULAs?username=${this.profile.username}`)
      console.log('New EULA Requirements:', eulas)
      this.profile.requiredEULAs = eulas
      sessionStorage.setItem('profile', JSON.stringify(this.profile))
    }
  }
})
